import { useDispatch, useSelector } from 'react-redux';
import { taskBoardActions } from '../../../../store/slices/taskBoardSlice/taskBoardSlice';
import { useEffect, useState } from 'react';
import { deleteSearchParams } from '../../../../shared/helpers';
import { resetModalData } from '../../model/slice/addModalSlice';

export const useModalAddNewTask = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { modalMode } = useSelector((store) => store.taskBoardReducer);
    const [previewEnable, setPreviewEnable] = useState(false);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                if (previewEnable) return;
                onHideModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [previewEnable]);

    const onHideModal = () => {
        dispatch(resetModalData());
        deleteSearchParams('activeTaskUid');
        dispatch(taskBoardActions.onModalMode(null));
    };
    return { modalMode, onHideModal, previewEnable, setPreviewEnable };
};
